/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soonki Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Mar 17 2023
 **/

import { EmotionJSX } from "@emotion/react/types/jsx-namespace";
import { StyledComponent } from "@emotion/styled";
import { AllHTMLAttributes } from "react";

type StyledBaseType<P> = StyledComponent<{ tag?: keyof JSX.IntrinsicElements } & P & AllHTMLAttributes<HTMLElement>>;

export function createStyled<P>(
	StyledBase: StyledBaseType<P>
): ({ ...rest }: React.ComponentProps<StyledBaseType<P>>) => EmotionJSX.Element;
export function createStyled<P>(
	StyledBase: StyledBaseType<P>,
	tag: keyof JSX.IntrinsicElements
): {
	[tag in keyof JSX.IntrinsicElements]: ({ ...rest }: React.ComponentProps<StyledBaseType<P>>) => EmotionJSX.Element;
};
export function createStyled<P>(StyledBase: StyledBaseType<P>, tag?: keyof JSX.IntrinsicElements) {
	if (!tag) {
		return ({ ...rest }: React.ComponentProps<typeof StyledBase>) => <StyledBase {...rest} />;
	} else {
		return {
			[tag]: ({ ...rest }: React.ComponentProps<typeof StyledBase>) => <StyledBase tag={tag} {...rest} />
		};
	}
}
